/**
 * Shipped Hmonglus catalog, counted from the mobile Learning Hub
 * (`learn-hmong/utils/resources.ts`) plus the bundled
 * `mobile-content.json` snapshot. Hmong Village is omitted.
 *
 * Decks / sheets / games / storybooks = unique hub links (dialect
 * duplicates collapsed). Words = unique titles in the snapshot.
 * Recordings = unique audio paths in that snapshot.
 */
export const LIBRARY_STATS = [
  { value: '20', label: 'Flashcard decks', detail: 'Colors, family, food, and more' },
  { value: '600+', label: 'Words to practice', detail: 'Adult and child recordings' },
  { value: '6', label: 'Storybooks', detail: 'Illustrated Hmong stories' },
  { value: '17', label: 'Term sheets', detail: 'Grammar and everyday phrases' },
  { value: '9', label: 'Games', detail: 'Matching, spelling, Ya! Ya!, Nab' },
  { value: '1,400+', label: 'Recordings', detail: 'Tap a word and hear it' },
] as const;
